import React from "react";
import Logo from "Components/Logo";
import styles from "Styles/components/session-loading.module.css";

const SessionLoading = ({
  heading = "載入中",
  subtext = "正在載入你的行銷診斷",
  showLogo = true,
}) => {
  return (
    <div className={styles.overlay}>
      {showLogo && (
        <div className={styles.logoWrapper}>
          <Logo />
        </div>
      )}
      <div className={styles.noisyCircleContainer} aria-hidden="true">
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 1000 1000"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <radialGradient id="loading-circle-gradient" spreadMethod="repeat">
              <stop offset="0" stopColor="#1754E7" />
              <stop offset="0.5" stopColor="#2B69FF">
                <animate
                  attributeName="stopColor"
                  values="#1754E7; #2B69FF; #1754E7;"
                  dur="4s"
                  repeatCount="indefinite"
                />
                <animate
                  attributeName="offset"
                  values="0.5; 1; 0.5; 0; 0.5;"
                  dur="10s"
                  repeatCount="indefinite"
                />
              </stop>
              <stop offset="1" stopColor="#1754E7" />
            </radialGradient>
          </defs>
          <circle
            fill="url(#loading-circle-gradient)"
            cx="500"
            cy="500"
            r="500"
          />
        </svg>
        <div className={styles.noisyCircleOverlay}>
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 1000 1000"
            xmlns="http://www.w3.org/2000/svg"
          >
            <filter id="loadingNoiseFilter">
              <feTurbulence
                type="fractalNoise"
                baseFrequency="0.65"
                numOctaves="3"
                stitchTiles="stitch"
              >
                <animate
                  attributeName="baseFrequency"
                  values="0.65; 0.6"
                  dur="10s"
                  repeatCount="indefinite"
                />
                <animate
                  attributeName="numOctaves"
                  from="1"
                  to="5"
                  dur="10s"
                  repeatCount="indefinite"
                />
              </feTurbulence>
            </filter>
            <rect
              width="100%"
              height="100%"
              filter="url(#loadingNoiseFilter)"
            />
          </svg>
        </div>
        <div className={styles.noisyCircleOverlay2} />
      </div>
      <div className={styles.noisyCircleContainerRight} aria-hidden="true">
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 1000 1000"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <radialGradient
              id="loading-circle-gradient-right"
              spreadMethod="repeat"
            >
              <stop offset="0" stopColor="#1754E7" />
              <stop offset="0.5" stopColor="#2B69FF">
                <animate
                  attributeName="stopColor"
                  values="#1754E7; #2B69FF; #1754E7;"
                  dur="4s"
                  repeatCount="indefinite"
                />
                <animate
                  attributeName="offset"
                  values="0.5; 1; 0.5; 0; 0.5;"
                  dur="10s"
                  repeatCount="indefinite"
                />
              </stop>
              <stop offset="1" stopColor="#1754E7" />
            </radialGradient>
          </defs>
          <circle
            fill="url(#loading-circle-gradient-right)"
            cx="500"
            cy="500"
            r="500"
          />
        </svg>
        <div className={styles.noisyCircleOverlay}>
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 1000 1000"
            xmlns="http://www.w3.org/2000/svg"
          >
            <filter id="loadingNoiseFilterRight">
              <feTurbulence
                type="fractalNoise"
                baseFrequency="0.65"
                numOctaves="3"
                stitchTiles="stitch"
              >
                <animate
                  attributeName="baseFrequency"
                  values="0.65; 0.6"
                  dur="10s"
                  repeatCount="indefinite"
                />
                <animate
                  attributeName="numOctaves"
                  from="1"
                  to="5"
                  dur="10s"
                  repeatCount="indefinite"
                />
              </feTurbulence>
            </filter>
            <rect
              width="100%"
              height="100%"
              filter="url(#loadingNoiseFilterRight)"
            />
          </svg>
        </div>
        <div className={styles.noisyCircleOverlay2} />
      </div>
      <div className={styles.dots}>
        <span className={styles.dot} />
        <span className={styles.dot} />
        <span className={styles.dot} />
      </div>
      <h2 className={styles.heading}>{heading}</h2>
    </div>
  );
};

export default SessionLoading;
